<h3 class="text-center">{{ updating ? 'Modification du relevé' : 'Nouveau relevé' }}</h3>

<form [formGroup]="ajoutReleveForm" (ngSubmit)="onSubmit()">
  <div id="category">
    <p id="category-title" class="text-center">Quel type d'énergie ?</p>
    <div class="d-flex justify-content-around align-items-end">
      @if (energiesEditables.includes(EnergieEnum.ELECTRICITE)) {
        <div class="mb-3">
          <label for="energie-elec" [class.active]="ajoutReleveForm.controls.energie.value === EnergieEnum.ELECTRICITE">
            <span class="icon icon-clea-electricite"></span><br><span class="title">{{ EnergieEnum.ELECTRICITE | energieName }}</span>
          </label>
          <input type="radio" name="energie" id="energie-elec" formControlName="energie" [value]="EnergieEnum.ELECTRICITE" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_releve_energie_elec">
        </div>
      }
      @if (energiesEditables.includes(EnergieEnum.GAZ)) {
        <div class="mb-3">
          <label for="energie-gaz" [class.active]="ajoutReleveForm.controls.energie.value === EnergieEnum.GAZ">
            <span class="icon icon-clea-gaz"></span><br><span class="title">{{ EnergieEnum.GAZ | energieName }}</span>
          </label>
          <input type="radio" name="energie" id="energie-gaz" formControlName="energie" [value]="EnergieEnum.GAZ" matomoClickCategory="Consommations" matomoClickAction="click" matomoClickName="conso_releve_energie_gaz">
        </div>
      }
      @if (energiesEditables.includes(EnergieEnum.FIOUL)) {
        <div class="mb-3">
          <label for="energie-fioul" [class.active]="ajoutReleveForm.controls.energie.value === EnergieEnum.FIOUL">
            <span class="icon icon-clea-eau"></span><br><span class="title">{{ EnergieEnum.FIOUL | energieName }}</span>
          </label>
          <input type="radio" name="energie" id="energie-fioul" formControlName="energie" [value]="EnergieEnum.FIOUL">
        </div>
      }
      @if (energiesEditables.includes(EnergieEnum.CHAUFFAGE)) {
        <div class="mb-3">
          <label for="energie-chauffage" [class.active]="ajoutReleveForm.controls.energie.value === EnergieEnum.CHAUFFAGE">
            <span class="icon icon-clea-chauffage"></span><br><span class="title">{{ EnergieEnum.CHAUFFAGE | energieName }}</span>
          </label>
          <input type="radio" name="energie" id="energie-chauffage" formControlName="energie" [value]="EnergieEnum.CHAUFFAGE">
        </div>
      }
      @if (energiesEditables.includes(EnergieEnum.ECS)) {
        <div class="mb-3">
          <label for="energie-ecs" [class.active]="ajoutReleveForm.controls.energie.value === EnergieEnum.ECS">
            <span class="icon icon-clea-eau-chaude"></span><br><span class="title">{{ EnergieEnum.ECS | energieName }}</span>
          </label>
          <input type="radio" name="energie" id="energie-ecs" formControlName="energie" [value]="EnergieEnum.ECS">
        </div>
      }
    </div>
  </div>

  @if (ajoutReleveForm.controls.energie.valid) {
    <div class="row" id="info">
      <div  class="col-sm-4" [class.offset-sm-1]="hasRightColumn()" [class.offset-sm-4]="!hasRightColumn()">
        <div id="date" class="field">
          <label for="date-field">Date du relevé :</label>
          <div class="input-group">
            <input class="form-control" [class.is-invalid]="ajoutReleveForm.controls.date.invalid && (ajoutReleveForm.controls.date.dirty || ajoutReleveForm.controls.date.touched)" id="date-field" placeholder="jj/mm/aaaa" name="date"
              autocomplete="false"
              ngbDatepicker #d="ngbDatepicker" (click)="d.toggle()" formControlName="date"/>
            <button class="btn btn-outline-secondary" (click)="d.toggle()" type="button">
              <fa-icon [icon]="faCalendar"></fa-icon>
            </button>
            <div class="invalid-feedback">
              @if (ajoutReleveForm.controls.date.errors?.correctDate) {
                <span>{{ ajoutReleveForm.controls.date.errors?.correctDate.reason}}<br/></span>
              }
              @if (ajoutReleveForm.controls.date.errors?.dateLibre) {
                <span>{{ ajoutReleveForm.controls.date.errors?.dateLibre.reason}}</span>
              }
            </div>
          </div>
        </div>
        <div id="value" class="field">
          <label for="value-field">Valeur (<span [innerHTML]="getUniteEnergie()"></span>) :</label>
          <input id="value-field" type="text" class="form-control" [class.is-invalid]="ajoutReleveForm.controls.valeur.invalid && (ajoutReleveForm.controls.valeur.dirty || ajoutReleveForm.controls.valeur.touched)" formControlName="valeur">          <div class="invalid-feedback">
          @if (ajoutReleveForm.controls.valeur.errors?.pattern) {
            <span>Un nombre est attendu</span>
          }
        </div>
      </div>
      <div id="nb-jours-absence" class="field">
        <label for="nb-jours-field">Nombre de jour d'absence :</label>
        <input id="nb-jours-field" type="number" class="form-control" formControlName="nombreJourAbsence">
      </div>
    </div>
    <div class="offset-sm-2 col-sm-4" >
      @if (chauffageEnMarcheIsDisplayed()) {
        <div id="chauffage-marche" class="field marche-toggle">
          <span class="label">Chauffage en marche :</span>
          <div class="btn-group" role="group">
            <input type="radio" class="btn-check" name="chauffageMarche" id="chauffage-marche-oui" formControlName="chauffageMarche" [value]="true">
            <label class="btn btn-light btn-custom-toggle" for="chauffage-marche-oui" [class.active]="ajoutReleveForm.controls.chauffageMarche.value == true">Oui</label>
            <input type="radio" class="btn-check" name="chauffageMarche" id="chauffage-marche-non" formControlName="chauffageMarche" [value]="false">
            <label class="btn btn-light btn-custom-toggle" for="chauffage-marche-non" [class.active]="ajoutReleveForm.controls.chauffageMarche.value == false">Non</label>
          </div>
        </div>
      }
      @if (refroidissementEnMarcheIsDisplayed()) {
        <div id="refroidissement-marche" class="field marche-toggle">
          <span class="label">Refroidissement en marche :</span>
          <div class="btn-group" role="group">
            <input type="radio" class="btn-check" name="refroidissementMarche" id="refroidissement-marche-oui" formControlName="refroidissementMarche" [value]="true">
            <label class="btn btn-light btn-custom-toggle" for="refroidissement-marche-oui" [class.active]="ajoutReleveForm.controls.refroidissementMarche.value == true">Oui</label>
            <input type="radio" class="btn-check" name="refroidissementMarche" id="refroidissement-marche-non" formControlName="refroidissementMarche" [value]="false">
            <label class="btn btn-light btn-custom-toggle" for="refroidissement-marche-non" [class.active]="ajoutReleveForm.controls.refroidissementMarche.value == false">Non</label>
          </div>
        </div>
      }
      @if (selectedEnergieHasPreviousReleve()) {
        <div id="type-de-releve" class="field">
          <span class="title">Type de relevé :</span>
          <div class="btn-group d-flex flex-column align-items-stretch" role="group">
            <input type="radio" class="btn-check" name="typeReleve" id="type-compteur" formControlName="typeReleve" [value]="TypeReleveConsoEnum.TYPE_RELEVE_COMPTEUR">
            <label for="type-compteur" class="btn" [class.active]="ajoutReleveForm.controls.typeReleve.value === TypeReleveConsoEnum.TYPE_RELEVE_COMPTEUR"><span>Relevé de compteur</span></label>
            <input type="radio" class="btn-check" name="typeReleve" id="type-releve" formControlName="typeReleve" [value]="TypeReleveConsoEnum.TYPE_RELEVE_FACTURE_INDEX_RELEVE">
            <label for="type-releve" class="btn" [class.active]="ajoutReleveForm.controls.typeReleve.value === TypeReleveConsoEnum.TYPE_RELEVE_FACTURE_INDEX_RELEVE"><span>Facture sur index relevé</span></label>
            <input type="radio" class="btn-check" name="typeReleve" id="type-estime" formControlName="typeReleve" [value]="TypeReleveConsoEnum.TYPE_RELEVE_FACTURE_INDEX_ESTIME">
            <label for="type-estime" class="btn" [class.active]="ajoutReleveForm.controls.typeReleve.value === TypeReleveConsoEnum.TYPE_RELEVE_FACTURE_INDEX_ESTIME"><span>Facture sur index estimé</span></label>
          </div>
        </div>
      }
    </div>
  </div>
}

@if (ajoutReleveForm.valid) {
  <div id="submit" class="text-center">
    @if (ajoutReleveForm.valid) {
      <button class="btn btn-lg btn-orange" type="submit" [disabled]="submitting" [@fadeInUpOnEnter]>
        @if (!submitting) {
          <span>Valider</span>
        }
        @if (submitting) {
          <fa-icon [icon]="faCircleNotch" animation="spin"></fa-icon>
        }
      </button>
    }
  </div>
}
</form>
